<ui-table
  *ngIf="clinics && clinics.length"
  [data]="clinics"
  [isWrapped]="false"
  (requestUpdate)="outputPaginationData($event)"
  [totalRecords]="totalRecords"
  [numberOfRows]="numberOfRows"
  [tblColor]="true"
  [tblRoundBottom]="true"
  [displayFilter]="['clinicId', 'clinicDescr', 'agent']"
  [templates]="[
    {
      title: 'translate.clinics.btnClinicUsersList',
      colClass: 'l-ta-center ui-p-3',
      template: btnClinicUsersList
    },
    {
      title: 'translate.clinics.btnCreateClinicUser',
      colClass: 'l-ta-center  ui-p-3',
      template: btnCreateClinicUser
    },
    {
      title: 'translate.clinics.edit',
      colClass: 'l-ta-center',
      template: editBtn
    }
  ]"
></ui-table>

<!-- [colSet]="[
{
  key: 'deliveryEmail',
  colClass: 'ui-p-6'
}
]" -->

<ng-template #editBtn let-row="row">
  <button
    class="btn-editUser"
    (click)="editClinic(row)"
    [tooltip]="'translate.clinics.edit' | translate"
  ></button>
</ng-template>

<ng-template #btnClinicUsersList let-row="row">
  <button
    (click)="getUsers(row)"
    [tooltip]="'translate.clinics.btnClinicUsersList' | translate"
  >
    <img src="assets\img\User_Filter.svg" />
  </button>
</ng-template>

<ng-template #btnCreateClinicUser let-row="row">
  <button
    (click)="createUser(row)"
    [tooltip]="'translate.clinics.btnCreateClinicUser' | translate"
  >
    <img src="assets\img\Add_User.svg" />
  </button>
</ng-template>
